import { PropsWithChildren, forwardRef } from 'react';

import { BackstagePage } from './BackstagePage';

export type PageProps = PropsWithChildren;

// eslint-disable-next-line @spotify-confidence/page-requires-tracking -- Layout wrapper, not an actual page
export const Page = forwardRef<HTMLDivElement, PageProps>(
  ({ children }: PageProps, ref) => {
    return (
      <BackstagePage ref={ref} themeId="other">
        {children}
      </BackstagePage>
    );
  },
);
